export default __webpack_public_path__ + "static/media/AL.5ddef505.svg";